type TimestampLike = {
  toDate?: () => Date;
  toMillis?: () => number;
};

export function timestampToMillis(value: unknown): number {
  if (!value) return 0;

  if (typeof value === 'string') {
    const millis = new Date(value).getTime();
    return Number.isFinite(millis) ? millis : 0;
  }

  if (typeof value === 'object') {
    const timestamp = value as TimestampLike;
    const millis = timestamp.toMillis?.();
    if (typeof millis === 'number' && Number.isFinite(millis)) return millis;

    const dateMillis = timestamp.toDate?.().getTime();
    if (typeof dateMillis === 'number' && Number.isFinite(dateMillis)) {
      return dateMillis;
    }
  }

  return 0;
}

export function shouldAdvanceReadReceipt(existingLastReadAt: unknown, nextLastReadAt: unknown): boolean {
  const nextMillis = timestampToMillis(nextLastReadAt);
  if (nextMillis <= 0) return false;

  const existingMillis = timestampToMillis(existingLastReadAt);
  return nextMillis >= existingMillis;
}

export function normalizeUnreadCount(value: unknown): number {
  const count = Number(value);
  if (!Number.isFinite(count) || count <= 0) return 0;
  return Math.floor(count);
}
